export default __webpack_public_path__ + "static/media/product_detail_img_Hk.ec42d2da.webp";